import React, { useState } from 'react';
import Sym from '../components/Sym';
import SectionHead from '../components/SectionHead';

/**
 * «Míralo en acción» — dos recorridos en video (los mismos del landing anterior,
 * hospedados en payslip.mx; también visibles en qa/prod). El clic abre un modal
 * que reproduce el .mp4 (soporta también enlaces de YouTube/Vimeo vía embedFor).
 */
const VIDEOS = [
  { title: 'Cómo funciona PaySlip', meta: 'Demo · empresa', src: 'https://payslip.mx/Video_Instrucciones_Empresa.mp4', delay: '0s' },
  { title: 'El portal del colaborador', meta: 'Recorrido · colaborador', src: 'https://payslip.mx/Video_Instrucciones_colaboradores.mp4', delay: '.6s' },
];

const embedFor = (src) => {
  if (!src) return null;
  const yt = src.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?autoplay=1`;
  const vm = src.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}?autoplay=1`;
  return null; // mp4 u otro → <video>
};

const VideoCard = ({ v, onOpen }) => (
  <div
    onClick={() => onOpen(v)}
    className="reveal-sm"
    style={{ position: 'relative', aspectRatio: '16/9', borderRadius: 20, overflow: 'hidden', border: '1px solid var(--well-border)', background: '#0A1324', cursor: 'pointer', transition: 'border-color .2s,transform .2s' }}
    onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(111,160,255,.5)'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--well-border)'; e.currentTarget.style.transform = 'none'; }}
  >
    <div style={{ position: 'absolute', inset: 0, background: 'repeating-linear-gradient(135deg,#0B1526,#0B1526 14px,#0E1A30 14px,#0E1A30 28px)', opacity: 0.7 }} />
    <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 50% 42%,rgba(47,107,255,.20),transparent 60%)' }} />
    <div style={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center' }}>
      <span style={{ width: 74, height: 74, borderRadius: '50%', background: '#2F6BFF', display: 'grid', placeItems: 'center', animation: `ls2-glowPulse 3s ease-in-out ${v.delay} infinite` }}>
        <Sym name="play_arrow" size={40} color="#fff" />
      </span>
    </div>
    <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, padding: '18px 20px', background: 'linear-gradient(to top,rgba(4,7,15,.9),transparent)', display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 12 }}>
      <div>
        <div style={{ font: "700 1.08rem 'Hanken Grotesk'", color: '#fff' }}>{v.title}</div>
        <div style={{ font: "500 .82rem 'Hanken Grotesk'", color: '#9DB0D0' }}>{v.meta}</div>
      </div>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, font: "600 .72rem 'IBM Plex Mono'", color: '#fff', background: 'rgba(47,107,255,.9)', padding: '6px 11px', borderRadius: 999, whiteSpace: 'nowrap' }}>
        <Sym name="play_arrow" size={15} color="#fff" />Ver
      </span>
    </div>
  </div>
);

const VideoTeaser2 = () => {
  const [open, setOpen] = useState(null);
  const embed = open ? embedFor(open.src) : null;
  return (
    <section style={{ maxWidth: 1200, margin: '0 auto', padding: '0 clamp(20px,5vw,40px) clamp(48px,7vw,96px)' }}>
      <SectionHead eyebrow="En video" title="Míralo en acción, no solo" accent="en texto"
        subtitle="Dos recorridos rápidos: cómo se conecta con el SAT y cómo lo viven tus colaboradores." />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(320px,1fr))', gap: 20, marginTop: 40 }}>
        {VIDEOS.map((v) => <VideoCard key={v.title} v={v} onOpen={setOpen} />)}
      </div>

      {open && (
        <div
          onClick={() => setOpen(null)}
          style={{ position: 'fixed', inset: 0, zIndex: 200, background: 'rgba(4,7,15,.82)', backdropFilter: 'blur(6px)', display: 'grid', placeItems: 'center', padding: 'clamp(16px,5vw,48px)' }}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ position: 'relative', width: 'min(900px,100%)', aspectRatio: '16/9', background: '#0A1324', border: '1px solid rgba(255,255,255,.1)', borderRadius: 18, overflow: 'hidden', boxShadow: '0 40px 90px -30px rgba(0,0,0,.9)' }}>
            <button type="button" onClick={() => setOpen(null)} aria-label="Cerrar"
              style={{ position: 'absolute', top: 12, right: 12, zIndex: 3, width: 40, height: 40, borderRadius: '50%', background: 'rgba(0,0,0,.5)', border: '1px solid rgba(255,255,255,.15)', color: '#fff', cursor: 'pointer', display: 'grid', placeItems: 'center' }}>
              <Sym name="close" size={22} color="#fff" />
            </button>
            {embed ? (
              <iframe title={open.title} src={embed} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={{ width: '100%', height: '100%', border: 0 }} />
            ) : open.src ? (
              <video src={open.src} controls autoPlay style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#000' }} />
            ) : (
              <div style={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center', textAlign: 'center', padding: 24 }}>
                <div>
                  <span style={{ width: 64, height: 64, borderRadius: '50%', background: 'rgba(47,107,255,.16)', display: 'grid', placeItems: 'center', margin: '0 auto 16px' }}>
                    <Sym name="movie" size={34} color="#6FA0FF" />
                  </span>
                  <div style={{ font: "700 1.2rem 'Source Serif 4'", color: '#fff', marginBottom: 8 }}>{open.title}</div>
                  <p style={{ font: "400 .98rem/1.5 'Hanken Grotesk'", color: '#9DB0D0', margin: 0, maxWidth: 380 }}>
                    Este video está por publicarse. En cuanto tengamos el archivo, se reproduce aquí.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default VideoTeaser2;
